<div
  class="segmented"
  role="radiogroup"
  [class.segmented-compact]="compact"
  [attr.aria-label]="label"
>
  @for (option of options; track trackById($index, option)) {
    <button
      type="button"
      role="radio"
      class="segmented-option"
      [attr.aria-checked]="option.id === value"
      (click)="select(option)"
    >
      {{ option.name }}
    </button>
  }
</div>
